import { TFunction } from "i18next";

/**
 * How a component should name the entity it is counting. Either an i18next key
 * whose `_one`/`_other` forms carry the plural (the default), or an explicit
 * singular/plural pair for tenant- or backend-provided names that have no key.
 */
export type EntityLabel = { key: string } | { one: string; other: string };

export const getEntityLabel = (
  label: EntityLabel,
  count: number,
  t: TFunction
): string =>
  "key" in label
    ? t(label.key, { count })
    : count === 1
      ? label.one
      : label.other;
